import React from 'react'
import cls from './common.scss'

const LoadingSkeleton = (props) => {
  return <div {...props} className={cls.loading_skeleton}></div>
}

export default LoadingSkeleton
;((_data) => {})([React])
